import(/* webpackMode: "eager", webpackExports: ["ClientOnlySPA"] */ "/app/src/app/(dynamic-root)/(static-root)/[[...slugs]]/client.js");
